import { Models } from "api/types";
import { notFalsy } from "toolbox/Guards";

export const hasAvailableTreatmentsToSelect = (
  membershipsResponse: Models<"PlatformUserMembershipModel">[]
): boolean => {
  return membershipsResponse.some((membershipObj) => {
    return membershipObj.membership.membershipRewardGroups?.some(
      (rg) =>
        rg.hasSelectableRewards &&
        rg.availableTreatmentsAmount > 0 &&
        rg.periodMonths !== 0
    );
  });
};

export const getAvailableSelectableTreatmentsCount = (
  membershipsResponse: Models<"PlatformUserMembershipModel">[]
): number => {
  return membershipsResponse.reduce((acc, membershipObj) => {
    const availableTreatmentsAmount =
      membershipObj.membership.membershipRewardGroups
        ?.filter((rg) => rg.periodMonths !== 0) // Filter out groups where periodMonths is 0
        .reduce((groupAcc, rg) => {
          if (rg.hasSelectableRewards) {
            return groupAcc + rg.availableTreatmentsAmount;
          }
          return groupAcc;
        }, 0) || 0; // Default to 0 if membershipRewardGroups is null or empty

    return acc + availableTreatmentsAmount;
  }, 0);
};

export const hasRolledOverTreatmentsToSelect = (
  membershipsResponse: Models<"PlatformUserMembershipModel">[]
): boolean => {
  return membershipsResponse.some((membershipObj) => {
    const hasAvailableTreatments =
      membershipObj.membership.membershipRewardGroups
        ?.filter(notFalsy)
        .some(
          (rg) =>
            rg.hasSelectableRewards &&
            rg.availableTreatmentsAmount > rg.quantityPerPeriod
        );

    return hasAvailableTreatments;
  });
};
